import store from '@/store/store'
//import getter from '@/store/getter'

export function setInterceptors (instance) {
  // Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      config.headers['X-AUTH-TOKEN'] = store.getters.getToken // store.state.token
      return config
    }, 
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  instance.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    }, function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response.status === 403 || error.response.status === 401) {
        store.dispatch('logout')
        window.location.href = '/'
      } else {
        return Promise.reject(error)
      }
    }
  )
  return instance
}